import { render, staticRenderFns } from "./InvitacionesConsumidasModal.vue?vue&type=template&id=9df2a8a2"
import script from "./InvitacionesConsumidasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesConsumidasModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports